<template>
  <section class="box formSection" id="contact">
    <div class="consult-wrapper">
      <img class="svg flower-01" src="/images/flowersWhite.svg" />
      <div class="content-section">
        <h2 class="content-title">{{ $t("home.form.title") }}</h2>
        <p class="content-paragraph sub-title-font-size">
          {{ $t("home.form.subTitle") }}
        </p>
        <ul class="content-list">
          <li>
            <span class="checkmark"
              ><v-icon color="white" icon="mdi-check-circle"></v-icon
            ></span>
            {{ $t("home.form.pointOne") }}
          </li>
          <li>
            <span class="checkmark"
              ><v-icon color="white" icon="mdi-check-circle"></v-icon
            ></span>
            {{ $t("home.form.pointTwo") }}
          </li>
          <li>
            <span class="checkmark"
              ><v-icon color="white" icon="mdi-check-circle"></v-icon
            ></span>
            {{ $t("home.form.pointThree") }}
          </li>
          <li>
            <span class="checkmark"
              ><v-icon color="white" icon="mdi-check-circle"></v-icon
            ></span>
            {{ $t("home.form.pointFour") }}
          </li>
          <li>
            <span class="checkmark"
              ><v-icon color="white" icon="mdi-check-circle"></v-icon
            ></span>
            {{ $t("home.form.pointFive") }}
          </li>
        </ul>
      </div>
      <div class="form-section">
        <img class="svg flower-02" src="/images/flowersWhite.svg" />
        <img class="svg flower-03" src="/images/flowersWhite.svg" />
        <div class="form-card">
          <h2 class="form-title">{{ $t("home.form.formTitle") }}</h2>
          <p class="form-subtitle sub-title-font-size">
            {{ $t("home.form.formSubTitle") }}
          </p>
          <v-form ref="form" v-model="form" @submit.prevent="submitForm">
            <!-- Name Field -->
            <v-text-field
              v-model="name"
              :label="$t('home.form.name')"
              :placeholder="$t('home.form.name')"
              variant="outlined"
              outlined
              dense
              :rules="[requiredRule]"
              required
            ></v-text-field>

            <!-- Phone Field -->
            <v-text-field
              v-model="phone"
              :label="$t('home.form.phone')"
              :placeholder="$t('home.form.phone')"
              variant="outlined"
              outlined
              dense
              :rules="[requiredRule, phoneRule]"
              required
            ></v-text-field>

            <!-- Email Field -->
            <v-text-field
              v-model="email"
              :label="$t('home.form.email')"
              :placeholder="$t('home.form.email')"
              variant="outlined"
              outlined
              dense
              :rules="[requiredRule, emailRule]"
              required
            ></v-text-field>

            <div ref="turnstile" class="d-flex justify-center mt-4"></div>

            <!-- Submit Button -->
            <v-btn type="submit" color="#2C2C2C" block :height="50" class="mt-10">
              שליחה
            </v-btn>
          </v-form>
          <p v-if="formAlert">{{formAlert}}</p>
          <img class="svg flower-04" src="/images/flowersWhite.svg" />
        </div>
      </div>
      <img class="svg flower-05" src="/images/hanging-flowers.svg" />
    </div>
  </section>
</template>

<script>
import FormService from "@/services/FormService";
import { getTurnstileToken } from "@/services/turnstile";

export default {
  data() {
    return {
      form: false,
      name: "",
      phone: "",
      email: "",
      formAlert: null,
      // Validation rules
      requiredRule: (value) => !!value || "שדה זה חובה",
      emailRule: (value) =>
        /.+@.+\..+/.test(value) || 'יש להכניס כתובת דוא"ל תקינה',
      phoneRule: (value) =>
        /^[0-9]{10,15}$/.test(value) || "יש להכניס מספר טלפון תקין",
    };
  },
  methods: {
    async submitForm() {
      if (!this.form) {
        return;
      }

      try {
        const token = await getTurnstileToken(
          "submit_form",
          this.$refs.turnstile
        );

        // Send form data to the server
        const response = await FormService.submitForm({
          name: this.name,
          phone: this.phone,
          email: this.email,
          token: token,
        });

        if (response.data.success) {
          // Clear form
          this.name = "";
          this.phone = "";
          this.email = "";
          this.form = false;
          this.formAlert = this.$t('home.form.successed');
          // Show success message
        }
      } catch (error) {
        this.formAlert = this.$t('home.form.failed');
        console.error("Form submission error:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.formSection {
  overflow: visible !important;
}
.formSection {
  display: flex;
  height: 680px;
  margin-top: 300px !important;
  margin-bottom: 150px !important;
  border-radius: 10px;
  overflow: hidden;
  .flower-05 {
    bottom: 5px;
    transform: translateY(100%);
    right: -10px;
  }
}

.consult-wrapper {
  background-color: $primaryColor;
  padding: 50px;
  position: relative;
  border-radius: 10px;
  display: flex;
  gap: 80px;
  width: 100%;
}

.flower-01 {
  top: -185px;
  right: -60px;
  rotate: 125deg;
}
/* Left Form Section */
.form-section {
  flex-basis: 40%;
  padding: 2rem;
  border-radius: 20px;
  background-color: #ffffff;

  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;

  .flower-02 {
    top: -110px;
    right: -41px;
    rotate: 284deg;
    height: 30%;
  }
  .flower-03 {
    top: -110px;
    left: -41px;
    rotate: 40deg;
    height: 35%;
  }
  .flower-04 {
    bottom: 0;
    right: 0;
    rotate: -2deg;
    height: 60%;
    transform: translateX(80%);
  }

  .form-card {
    text-align: center;
    h2 {
      font-size: 35px;
      font-weight: bold;
      text-align: start;
      margin-bottom: 0.5rem;
    }
    p {
      text-align: start;
      font-size: 20px;
      margin-bottom: 40px;
      color: #555;
    }
  }

  .form-group {
    margin-bottom: 1rem;

    input {
      width: 100%;
      padding: 0.8rem;
      border: 1px solid #ddd;
      border-radius: 5px;
      font-size: 1rem;
      &:focus {
        outline: none;
        border-color: #a87b5f;
      }
    }
  }

  .submit-button {
    width: 100%;
    padding: 0.8rem;
    background-color: black;
    color: white;
    font-size: 1rem;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    &:hover {
      background-color: #333;
    }
  }
}

/* Right Content Section */
.content-section {
  background: #ffffff00;
  flex-basis: 60%;
  margin: 40px 0px;
  position: relative;

  .content-title {
    font-size: 45px;
    font-weight: bold;
    margin-bottom: 20px;
    color: white;
  }

  @media (max-width: 601px) {
    .content-title {
      font-size: 25px;
    }
  }

  .content-paragraph {
    font-size: 20px;
    color: white;
    font-weight: 300;
    margin-bottom: 30px;
  }

  .content-list {
    list-style: none;
    padding: 0;

    li {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      font-size: 20px;
      font-weight: 300;
      color: white;

      .checkmark {
        color: green;
        font-weight: bold;
        margin-left: 20px;
      }
    }
  }
}
.isTablet {
  .formSection {
    margin-top: 500px !important;
  }
}

.isMobile,
.isTablet {
  .flower-01 {
    top: -230px;
    right: -35px;
  }
  .flower-02 {
    top: -140px;
    right: -35px;
    rotate: 282deg;
    height: 40%;
  }
  .formSection {
    margin-top: 580px !important;
    height: unset !important;
  }

  .consult-wrapper {
    gap: 20px;
    flex-direction: column;
    padding: 10px;
  }

  .form-section,
  .content-section {
    padding: 10px;
    flex: none;
    width: 100%;
  }
  .content-list{
    li{
      font-size: 18px;
    }
  }
  @media (max-width: 601px) {
    .form-title {
      font-size: 25px !important;
    }

    .form-section {
      padding: 15px;
    }
  }
}
</style>
